import {
  GET_BD,
  VIP_SWITCH_BD,
  OPEN_BD_DIALOG,
  CLOSE_BD_DIALOG,
  GET_BD_DROPDOWN,
} from "./type";

const initialState = {
  bdData: [],
  total: 0,
  dialog: false,
  dialogData: null,
  bdDropdown: [],
};

const bdReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BD:
      return {
        ...state,
        bdData: action.payload.bdData,
        total: action.payload.total,
      };

    case VIP_SWITCH_BD:
      return {
        ...state,
        bdData: state.bdData.map((item) =>
          item._id === action.payload
            ? { ...item, isActive: !item.isActive }
            : item,
        ),
      };

    case OPEN_BD_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };

    case CLOSE_BD_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default bdReducer;
